// extracted by mini-css-extract-plugin
module.exports = {"tooltipIcon":"VehiclesCell_tooltipIcon__1cNuV","vehicleContent":"VehiclesCell_vehicleContent__13QeR","tooltip":"VehiclesCell_tooltip__1Voi9"};